export default "__VITE_ASSET__luV34Hvv__"